module.exports = __webpack_public_path__ + "static/media/coffee.eda0e44b.svg";